import { MapPin } from 'lucide-react'

import { normalizeGeo } from './use-area-polygon'
import { cn } from '@/lib/utils'

interface Props {
    /** Toạ độ vùng trồng, đúng cấu trúc đang lưu ở grower area. */
    paths?: unknown[]
    markers?: unknown[]
    className?: string
}

/**
 * Ảnh thu nhỏ hình thửa: vẽ polygon bằng SVG ngay từ toạ độ đã lưu, KHÔNG gọi
 * Google Maps. Một danh sách 20 nhật ký mà nhúng 20 bản đồ thật thì vừa tốn
 * quota vừa giật trên điện thoại của hộ dân; ảnh vệ tinh chỉ cần khi bấm phóng
 * to (`GrowerAreaMap`). Vùng chưa có toạ độ thì hiện ghim mờ thay vì ô trống.
 */
export function AreaPolygonThumb({ paths, markers, className }: Props) {
    const geo = normalizeGeo(paths, markers)
    if (geo.paths.length < 3) {
        return (
            <div
                className={cn(
                    'flex items-center justify-center bg-muted text-muted-foreground',
                    className,
                )}
            >
                <MapPin className="size-4" />
            </div>
        )
    }

    const lats = geo.paths.map((p) => p.lat)
    const lngs = geo.paths.map((p) => p.lng)
    const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2
    const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2
    // Khung vuông theo cạnh dài nhất → hình thửa giữ đúng tỉ lệ, không bị bóp
    // méo khi vùng dài và hẹp. 1e-6 chặn chia cho 0 khi các đỉnh trùng nhau.
    const span =
        Math.max(
            Math.max(...lats) - Math.min(...lats),
            Math.max(...lngs) - Math.min(...lngs),
            1e-6,
        ) * 1.25
    const points = geo.paths
        .map((p) => {
            const x = ((p.lng - centerLng) / span + 0.5) * 100
            // Vĩ độ tăng về phía bắc, trục y của SVG tăng xuống dưới → lật dấu.
            const y = ((centerLat - p.lat) / span + 0.5) * 100
            return `${x.toFixed(2)},${y.toFixed(2)}`
        })
        .join(' ')

    return (
        <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid meet"
            role="presentation"
            className={cn('bg-muted', className)}
        >
            <polygon
                points={points}
                className="fill-primary/25 stroke-primary"
                strokeWidth={2}
                strokeLinejoin="round"
                vectorEffect="non-scaling-stroke"
            />
        </svg>
    )
}
